import Vue from 'vue'
import postConstant from '@/modules/post/config/postConstant'
Vue.prototype.$postTypes = [
  postConstant.TYPE_INFORMATION,
  postConstant.TYPE_EVENT,
  postConstant.TYPE_POST,
]
export default {
  onAppLaunch(vm) {
    Vue.prototype.$postSelector = ({ applyCallback, closeCallback = null, usedList = [] }) => {
      vm.$targetSelector.active(vm, {
        title: vm.i18n('module.post'),
        bodySlot: () => import('modules/post/selector/postList.vue'),
        max: 1,
        applyCallback,
        closeCallback,
        usedList,
      })
    }
  }
}